import React, {useEffect, useState} from "react";
import {useForm} from "react-hook-form";
import axios from "axios";
import generalTools from "../../sharecomponents/generalTools";
import Swal from "sweetalert2";

import {PHP_API} from "../../../utils/Common";
import MyLoader from "../../sharecomponents/MyLoader";
// import ActividadPorSemana from "./components/ActividadPorSemana";
import LaborCantidad from "./components/LaborCantidad";

const InventarioLabores = () => {

    const [loader, setLoader] = useState(false);
    const [areas, setAreas] = useState([]);
    const [flores, setFlores] = useState([]);
    const [ranchos, setRanchos] = useState([]);
    const [valvulas, setValvulas] = useState([]);
    const [labores, setLabores] = useState([]);
    var [showValvulas, setShowValvulas] = useState(true);

    // -- Formulario
    const { getValues, setValue} = useForm({
        defaultValues: {
            no_semana: "",
            area: "",
            valvula: "",
            rancho:'',
            flor:null,
        }
    });

    useEffect(() => {
        getInfos();
       // getActividades();

    }, []);

    const setSemana = (element) => {  setValue('no_semana', element); }
    const selectFlor = (element) => { setValue('flor', element); }
    const selectRacnho = (element) => { setValue('rancho', element); }
    
    const setArea = (element) => {
        setShowValvulas(showValv(element)) ;
        setValue('area', element);
        getActividades();
        getFlores(); 
    }

    const showValv = (element) => {
        for (let i = 0; i < areas.length; i++) {
            if(areas[i].key == element && areas[i].text == 'Vivero') return false;
        }
        return true;
    }

    const selectValvula = (element) => {
       setValue('valvula', element);
       getFlores(); 
    }

    const setCantidad = (items) => {
        const { i, j, value } = items;
        //console.log(items);
        labores[i].semana[j].cantidad = value;
        setLabores([...labores]);
    }

    

    

    const getInfos = () => {
        setLoader(true);
        axios.get(PHP_API + 'nomina/get-infos-web')
            .then(({data: {data}}) => {
                
                const {areas, valvulas,ranchos} = data;
                setAreas(areas);
                setValvulas(valvulas);
                setRanchos(ranchos);
                setLoader(false);
            });
    }

    const getActividades = () => {
        setLoader(true);
        axios.post(`${PHP_API}nomina/get-actividades-semana`,{areaID:getValues().area === ""?null:getValues().area})
            .then(({data: {data}}) => {
                setLabores(data);
                console.log(data)
                setLoader(false);
            })
    };

    const getFlores = () => {
        setLoader(true);
        let aid = getValues().area === ""? null :   getValues().area;
        let vid = getValues().valvula === ""? null: getValues().valvula;
        axios.post(`${PHP_API}nomina/get-flores-inventario`,
            {areaID:aid, valvulaID:vid})
            .then(({data: {data}}) => {
                const _flores = data.data;
                setFlores(_flores);
                setLoader(false);
            })
    };

    

    const submit = (data) => {
        if(!canSave(true)) return;
        // -- confirm send data
        Swal.fire({
            title: '¿Estás seguro?',
            text: "Se enviará la información de las actividades laborales de la semana",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Enviar',
            cancelButtonText: 'Cancelar'
        }).then(({ isConfirmed }) => {
            if (!isConfirmed) {
                return;
            }
        let argumentos ={
            labores:new generalTools().getActiveAtivitys(labores),
            area:getValues().area,
            rancho:getValues().rancho,
            no_semana:getValues().no_semana,
            valvula:getValues().valvula,
            flor:getValues().flor 
        };
           
            setLoader(true);
            axios.post(`${PHP_API}nomina/set-inv-labores`, argumentos)
                .then(({data}) => {
                    if(data.success){
                        Swal.fire({
                            title: 'Registro exitoso',
                            text: "Se agregó correctamente la actividad",
                            icon: 'success',
                            showCancelButton: false,
                            confirmButtonColor: '#3085d6',
                            cancelButtonColor: '#d33',
                            confirmButtonText: 'Aceptar',
                            cancelButtonText: 'Cancelar'
                        }).then(()=>{window.location.reload();});
                    }
                    setLoader(false);
                }).catch(e => {
                    console.log('error',e);
                    setLoader(false);
                });
        });
    }

    const canSave = (avisar) =>{
        let aviso = "";
        let counter = 0;

        if(getValues().no_semana == "" ){ 
            counter++;
            aviso+=`${counter}) Agregue la semana en que se aplicará esta actividad.   `;
        }

        if(getValues().area == "" ){ 
            counter++;
            aviso+=`${counter}) Seleccione un área.   `;
        } 

        if(getValues().valvula == "" && !vivieroSeleccionado()){ 
            counter++;
            aviso+=`${counter}) Es necesario seleccionar una valvula.   `;
        } 

        if(vivieroSeleccionado() && getValues().rancho == ''){
            counter++;
            aviso+=`${counter}) Seleccione un rancho.   `;
        }

        if(getValues().flor == null){ 
            counter++;
            aviso+=`${counter}) Seleccione un tipo de flor.   `;
        } 

        if((getValues().no_semana!="" && getValues().no_semana.length <3 )|| getValues().no_semana.length>4){
            counter++;
            aviso+=`${counter}) Formato de numero de semana incorrecto.   `;
        }else if(getValues().no_semana!=""){
            let anio = getValues().no_semana.substring(0,getValues().no_semana.length == 3?1:2);
            let semana = getValues().no_semana.substring(getValues().no_semana.length == 3?1:2);
            let week =new generalTools().getWeek(new Date());
            let actual = parseInt(new Date().getFullYear().toString().substring(2,4));
            try {
                semana = parseInt(semana);
                anio = parseInt(anio);
                
                if(semana < 1 || semana > 56){
                    counter++;
                    aviso+=`${counter}) Formato de numero de semana incorrecto: el valor de la semana no es correcto.   `;
                }
                if(anio<actual){
                    counter++;
                    aviso+=`${counter}) Formato de numero de semana incorrecto: No es posible agendar actividades para años anteirores al actual.   `;
                }else if(anio<=actual && week > semana){
                    counter++;
                    aviso+=`${counter}) Formato de numero de semana incorrecto: Solo es posible agendar actividades para fechas futuras. semana actual: #${week}.   `;
                }

            } catch (error) {
                
            }
        }

        if(!new generalTools().someWeekAtivity(labores)){
            counter++;
                    aviso+=`${counter}) Es necesario agregar alguna cantidad de producción al menos a un día de las actividades diponibles   `;
        }

        if(aviso.length>0){ 
            if(avisar === true){
                Swal.fire({
                    title: 'Un momento',
                    text: "Para poder guardar la actidad es necesario que realice lo siguiente: "+aviso,
                    icon: 'warning',
                    showCancelButton: false,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Aceptar',
                    cancelButtonText: 'Cancelar'
                })
            }
            return false;
        }
        return true;
    }

    const vivieroSeleccionado = () => {
       if(!getValues().area|| getValues().area === "") return false;
       for (let i = 0; i < areas.length; i++) {
        if(areas[i].key == getValues().area && areas[i].text.toLowerCase() == 'vivero') return true;
       }
       return false;
    }



    return (
        <>
            <div className="w-full p-1 right-0">
                <div className="bg-white border rounded shadow-xl">
                    <div className="border-b rounded-t p-3 bg-orange-900">
                        <h5 className="font-bold uppercase text-white">Inventario de Actividades / Labores</h5> 
                    </div>

                    <div className="col-sm-22 p-2 "> 
                        <div className="row">
                            <div className="form-group form-group-sm col-lg-1 mt-1" style={{fontWeight:'bold'}}>
                                <label>No. Semana</label>
                                <input type="text" className="form-control form-control-sm" id="semana" placeholder="semana" required onChange={(event) => setSemana(event.target.value)}/>
                            </div>

                            <div className="form-group form-group-sm col-lg-2 mt-1" style={{fontWeight:'bold'}}>
                                <label>Área</label>
                                <select className="form-control form-control-sm" id="elementos_por_pagina" onChange={(event) => setArea(event.target.value)} style={{fontSize:"small"} }>
                                    <option defaultValue={""} >Seleccione un área</option>
                                    {
                                        areas.map((area)=>{
                                            return(
                                                <option  key={'area'+area.key} value={area.value} >{area.text}</option>
                                            );
                                        })
                                    }
                                </select>
                            </div>

                            {showValvulas && <div className="form-group form-group-sm col-lg-2 mt-1" style={{fontWeight:'bold'}}>
                                <label>Válvula</label>
                                <select className="form-control form-control-sm" id="elementos_por_pagina" onChange={(event) => selectValvula(event.target.value)} style={{fontSize:"small"} }>
                                    <option defaultValue={""} >Seleccione una válvula</option>
                                    {
                                        valvulas.map((valv)=>{
                                            return(
                                                <option  key={'valv'+valv.key} value={valv.value} >{valv.text}</option>
                                            );
                                        })
                                    }
                                </select>
                            </div>}
                            
                            {!showValvulas && <div className="form-group form-group-sm col-lg-2 mt-1" style={{fontWeight:'bold'}}>
                                <label>Rancho</label>
                                <select className="form-control form-control-sm" id="ranchosSelect" onChange={(event) => selectRacnho(event.target.value)}style={{fontSize:"small"} }>
                                    <option defaultValue={""} >Seleccione un rancho</option>
                                    {
                                        ranchos.map((ran)=>{
                                            return(
                                                <option  key={'ranchor'+ran.key} value={ran.value} >{ran.text}</option>
                                            );
                                        })
                                    }
                                </select>
                            </div>}

                            {flores.length>0 && <div className="form-group form-group-sm col-lg-2 mt-1" style={{fontWeight:'bold'}}>
                                <label>Tipo de flor</label>
                                <select className="form-control form-control-sm" id="floresSelect" onChange={(event) => selectFlor(event.target.value)} style={{fontSize:"small"} }>
                                    <option defaultValue={""} >Seleccione un tipo de flor</option>
                                    {
                                        flores.map((florr)=>{
                                            return(
                                                <option  key={'flor'+florr.key} value={florr.value} >{florr.text}</option>
                                            );
                                        })
                                    }
                                </select>
                            </div>}

                            <div className="form-group form-group-sm col-lg-2 mt-1 mb-5" style={{fontWeight:'bold'}}>
                                <br/>
                                <button className="btn btn-info btn-sm shadow text-white rounded" 
                                style={{backgroundColor:'#0E6FD0',fontWeight:'bold'}}
                                onClick={submit}>
                                    <i className='save icon pr-2 text-white'></i>
                                     Guardar actividad
                                </button>
                            </div>
                            
                        </div>
                        
                        {/*  Actividades por semana  */}
                        {/*<ActividadPorSemana />*/}
                      { labores.length> 0 &&  <div className="table-container">
                            <table className="table table-sm table-striped">
                                <thead>
                                    <tr>
                                        <th scope="col" className="ml-3">Actividad</th>
                                        <th className="text-center">Lunes</th>
                                        <th className="text-center">Martes</th>
                                        <th className="text-center">Miercoles</th>
                                        <th className="text-center">Jueves</th>
                                        <th className="text-center">Viernes</th>
                                        <th className="text-center">Sabado</th>
                                        <th className="text-center">Domingo</th>
                                    </tr>
                                </thead>
                                <tbody>
                                {labores.map((labor, index) => (
                                    <tr key={index}>
                                        <td>{labor.labor} <span className="ml-3 text-secondary" style={{fontSize:'x-small',fontWeight:'bold'}}>{labor.unidad} por día</span></td>
                                        {labor.semana.map((s, i) => (
                                            // <td key={i}>{ s.cantidad }</td>
                                            <td key={i}>
                                                <div className="ml-2 mr-2">
                                                <LaborCantidad
                                                    cantidad={s.cantidad}
                                                    semana={s}
                                                    labor={labor}
                                                    i={index}
                                                    j={i}
                                                    callback={setCantidad}
                                                />
                                                </div>
                                            </td>
                                        ))}
                                    </tr>
                                ))}
                                </tbody>
                            </table>
                        </div>}
                        {labores.length == 0 && <div className="h4 text-center text-secondary p-5">Para empezar seleccione un áera</div>}
                        {/*<h4 className='ui dividing header'>Actividad por semana</h4>
                        <table className='ui small striped very compact table'>
                            <thead>
                            <tr>
                                <th>Actividad</th>
                                <th>Lunes</th>
                                <th>Martes</th>
                                <th>Miercoles</th>
                                <th>Jueves</th>
                                <th>Viernes</th>
                                <th>Sabado</th>
                                <th>Domingo</th>
                            </tr>
                            </thead>
                            <tbody>
                            {labores.map((labor, index) => (
                                <tr key={index}>
                                    <td>{labor.labor}</td>
                                    {labor.semana.map((s, i) => (
                                        // <td key={i}>{ s.cantidad }</td>
                                        <td key={i}>
                                            <LaborCantidad
                                                cantidad={s.cantidad}
                                                semana={s}
                                                labor={labor}
                                                i={index}
                                                j={i}
                                                callback={setCantidad}
                                            />
                                        </td>
                                    ))}
                                </tr>
                            ))}
                            </tbody>
                        </table>*/}
                    </div>
                </div>
            </div>

            {loader && <MyLoader/>}
        </>
    )
}

export default InventarioLabores;